import InputMask from 'react-input-mask'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ErrorModal from '../application/ErrorModal'
import validator from '../../helpers/validator'
import { setAttribute } from '../../actions/registration'

import logoImage from '../../assets/images/logo.png'

class HomeStart extends Component {
  constructor(props) {
    super(props)

    this.onBirthdayChange = this.onBirthdayChange.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.onNameChange = this.onNameChange.bind(this)
    this.onNameKeyDown = this.onNameKeyDown.bind(this)

    this.state = {
      error: '',
      birthday: '',
      name: '',
    }
  }

  onBirthdayChange(event) {
    this.props.setAttribute('birthday', event.currentTarget.value)
    this.setState({
      birthday: event.currentTarget.value,
    })
  }

  onNameChange(event) {
    this.props.setAttribute('name', event.currentTarget.value)
    this.setState({
      name: event.currentTarget.value,
    })
  }

  onNameKeyDown(event) {
    if (event.keyCode === 13) {
      if (this.state.name.length > 0) {
        this.birthdayInput.input.focus()

        event.preventDefault()
      }
    }
  }

  onFormSubmit(event) {
    event.preventDefault()

    if (!validator.validateRequired.isValueValid(this.state.name)) {
      this.setState({
        error: 'Por favor, informe seu nome',
      })
      this.modal.show()
      return
    }

    if (!validator.validateDate.isValueValid(this.state.birthday, 'DD/MM/YYYY')) {
      this.setState({
        error: 'Por favor, informe uma data de nascimento válida',
      })
      this.modal.show()
      return
    }

    this.props.setAttribute('start-ok', true)

    this.props.history.push('/registration')
  }

  render() {
    return (
      <div className="background home-primeira-tela">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <img src={logoImage} alt="Descubra seu futuro" title="Descubra seu futuro" />
              </div>
            </div>

            <div className="col-md-2" />

            <div className="col-md-8">
              <div className="formulario-um">
                <form className="form-inline" onSubmit={this.onFormSubmit}>
                  <div className="form-group">
                    <label className="sr-only" htmlFor="name">seu nome</label>
                    <input
                      ref={(ref) => { this.nameInput = ref }}
                      className="camposformulario form-control"
                      id="name"
                      onChange={this.onNameChange}
                      onKeyDown={this.onNameKeyDown}
                      placeholder="seu nome"
                      type="text"
                    />
                  </div>

                  <div className="form-group">
                    <label className="sr-only" htmlFor="birthday">data de nascimento</label>
                    <InputMask
                      ref={(ref) => { this.birthdayInput = ref }}
                      className="camposformulario form-control"
                      id="birthday"
                      mask="99/99/9999"
                      onChange={this.onBirthdayChange}
                      placeholder="data de nascimento"
                      type="text"
                    />
                  </div>
                  <div className="form-group-bt-continuar">
                    <button
                      className="btn btn-primary"
                      type="submit"
                    >
                      Continuar
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-md-2" />
          </div>
        </div>

        <ErrorModal
          ref={(ref) => { this.modal = ref }}
          message={this.state.error}
        />
      </div>
    )
  }
}

HomeStart.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  setAttribute: PropTypes.func.isRequired,
}

HomeStart.defaultProps = {
  history: {
    push: () => { },
  },
}

const mapDispatchToProps = {
  setAttribute,
}

export default connect(null, mapDispatchToProps)(HomeStart)



// WEBPACK FOOTER //
// ./src/components/home/Start.js